import React from "react";

const Services = () => {
  return (
    <section className="min-h-screen bg-[#d2e5e4] py-20 px-4 md:px-20 text-[#3d302c] font-sans">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">Our Services</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
        {/* MedOps */}
        <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition">
          <h3 className="text-2xl font-semibold mb-4">MedOps</h3>
          <p className="text-base leading-relaxed mb-4">
            MedOps is your digital stethoscope — a comprehensive solution for
            AI-powered clinical documentation, real-time symptom assessment, and
            patient data intelligence.
          </p>
          <ul className="list-disc list-inside text-sm space-y-2">
            <li>Smart Patient History Tracking</li>
            <li>Auto-generated Medical Notes</li>
            <li>AI Symptom Analyzer</li>
            <li>Seamless EHR Integration</li>
          </ul>
        </div>

        {/* PharmaConnect */}
        <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition">
          <h3 className="text-2xl font-semibold mb-4">PharmaConnect</h3>
          <p className="text-base leading-relaxed mb-4">
            PharmaConnect bridges the gap between pharmacies and AI — helping
            manage inventory, optimize stock flow, and improve patient adherence
            like a pro.
          </p>
          <ul className="list-disc list-inside text-sm space-y-2">
            <li>Automated Inventory Forecasting</li>
            <li>Expiry Tracking & Refill Alerts</li>
            <li>Vendor Insights & Order Optimization</li>
            <li>24/7 Dashboard Access</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Services;
